import * as Sentry from '@sentry/browser';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { message } from 'antd';
import { ConnectedRouter } from 'connected-react-router';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';

import { App } from 'app/components/App';
import { store } from 'app/redux/store';
import { env } from 'app/utils/env';
import { history } from 'app/utils/history';

message.config({
  duration: 5,
});

// Prevent file drag & drop
window.addEventListener('dragover', (e) => e.preventDefault(), false);
window.addEventListener('drop', (e) => e.preventDefault(), false);

// Sentry
Sentry.init({
  environment: env.env,
  dsn: env.sentryDsn,
});

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const stripePromise = loadStripe(env.stripeKey);

root.render(
  <Provider store={store}>
    {/*
      // @ts-ignore- library typing error */}
    <ConnectedRouter history={history}>
      <QueryClientProvider client={queryClient}>
        <Elements stripe={stripePromise}>
          <App />
        </Elements>

        {/* Uncomment the following line to enable React Query Devtools */}
        {/* <ReactQueryDevtools initialIsOpen={false} /> */}
      </QueryClientProvider>
    </ConnectedRouter>
  </Provider>
);
